import "./saga";
export * from "./slice";

const getAuditorState = (state) => state.auditor;

export const getModelList = (state) => {
  const _state = getAuditorState(state);
  return _state.modelList || [];
};

export const getReportFormatsList = (state) => {
  const _state = getAuditorState(state);
  return _state.reportFormats || [];
};

export const getModelDetails = (state) => {
  const _state = getAuditorState(state);
  return _state.modelDetails;
};

export const getModelDetailsLoading = (state) => {
  const _state = getAuditorState(state);
  return _state.modelDetailsLoading;
};

export const getModelDetailsError = (state) => {
  const _state = getAuditorState(state);
  return _state.modelDetailsError;
};

export const getDeactivateModelSuccess = (state) => {
  const _state = getAuditorState(state);
  return _state.deactivateModelSuccess;
};

export const getReactivateModelSuccess = (state) => {
  const _state = getAuditorState(state);
  return _state.reactivateModelSuccess;
};

export const getAllocateModelSuccess = (state) => {
  const _state = getAuditorState(state);
  return _state.allocateModelSuccess;
};

export const getAuditReportBlueprints = (state) => {
  const _state = getAuditorState(state);
  return _state.reportBlueprints;
};

export const getCurrentAuditReport = (state) => {
  const _state = getAuditorState(state);
  return _state.currentAuditReport;
};
